import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useCheckExternalIntegrationEnableAbilityMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (enableAbility: string, variables: { integrationProvider: Api.IntegrationProvider }) => void;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ integrationProvider }: { integrationProvider: Api.IntegrationProvider }) => {
			return userSession.webServiceHelper.callAsync<string>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `account/integrations/${integrationProvider}/enableAbility`,
				}),
				'GET'
			);
		},
		onError,
		onSuccess,
	});
};
